import { render, staticRenderFns } from "./form-title.vue?vue&type=template&id=e7879792&scoped=true&"
import script from "./form-title.vue?vue&type=script&lang=ts&"
export * from "./form-title.vue?vue&type=script&lang=ts&"
import style0 from "./form-title.vue?vue&type=style&index=0&id=e7879792&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7879792",
  null
  
)

export default component.exports